// extracted by mini-css-extract-plugin
export var resizer = "_fj-0";